module.exports = __webpack_public_path__ + "img/decor-film.a10afb4e.png";